// extracted by mini-css-extract-plugin
export default {"rating":"hR-z","numberOfStars":"iR-z","count":"jR-z","barGraphSpacing":"kR-z","barGraph":"lR-z"};